(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_banner-parent"] && !Shopify.designMode) return;
  try {
    function initBannerGrid() {
    const bannerParents = document.querySelectorAll('.banner-parent');
    bannerParents.forEach(function (bannerParent) {
      const bannerItems = bannerParent.querySelectorAll('.banner-item');
      bannerParent.classList.add('grid-' + bannerItems.length);
    });
  }

  initBannerGrid();  
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initBannerGrid);
    document.addEventListener('shopify:section:deselect', initBannerGrid);
    document.addEventListener('shopify:section:reorder', initBannerGrid);
    document.addEventListener('shopify:block:select', initBannerGrid);
    document.addEventListener('shopify:block:deselect', initBannerGrid);
    document.addEventListener('shopify:section:load', initBannerGrid);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-order-bump"] && !Shopify.designMode) return;
  try {
    class OrderBumpCards extends HTMLElement {
      connectedCallback(){
        this.section = this.closest('[id^="shopify-section-"]') || document;
        this.freeShip = parseInt(this.dataset.freeShip) || 34900;
        this.moneyFormat = this.dataset.moneyFormat || '';
        this.cards = Array.prototype.slice.call(this.querySelectorAll('.obp__card[role="checkbox"]'));
        this.foot = this.querySelector('[data-foot]');
        this.totalEl = this.querySelector('[data-total]');
        this.ship = this.querySelector('[data-ship]');
        this.shipFill = this.querySelector('[data-ship-fill]');
        this.shipMsg = this.querySelector('[data-ship-msg]');
        var self = this;
        this.cards.forEach(function(card){
          card.addEventListener('click', function(){ self.toggle(card); });
          card.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); self.toggle(card); } });
        });
        var qc = this.section.querySelector('quantity-discount-cards');
        if(qc){ qc.addEventListener('click', function(){ setTimeout(function(){ self.recalc(); }, 30); }); }
        this.section.addEventListener('click', function(e){
          var btn = e.target.closest('button[name="add"], .product-form__submit');
          if(!btn || !self.section.contains(btn)) return;
          if(self.selected().length === 0) return;
          e.preventDefault(); e.stopImmediatePropagation();
          self.checkout(btn);
        }, true);
        this.recalc();
      }
      selected(){ return this.cards.filter(function(c){ return c.classList.contains('is-on'); }); }
      toggle(card){
        card.classList.toggle('is-on');
        var on = card.classList.contains('is-on');
        card.setAttribute('aria-checked', on ? 'true' : 'false');
        var lbl = card.querySelector('.obp__btn-lbl'); if(lbl) lbl.textContent = on ? 'Adicionado' : 'Adicionar';
        this.recalc();
      }
      anchorPrice(){
        var qc = this.section.querySelector('quantity-discount-cards');
        if(qc){
          var active = qc.querySelector('.qty2__opt.is-active');
          var unit = parseInt(qc.dataset.unitPrice);
          if(active && unit){ var q=parseInt(active.dataset.quantity), d=parseInt(active.dataset.discount); var t=unit*q; return t - Math.floor(t*d/100); }
        }
        var vi = this.section.querySelector('form[id^="product-form-"] [name="id"]') || this.section.querySelector('input.product-variant-id');
        var qi = this.section.querySelector('input.quantity-input');
        var pj = this.section.querySelector('.productJson');
        if(vi && pj){ try{ var data=JSON.parse(pj.textContent); var v=data.variants.find(function(x){return x.id===parseInt(vi.value);}); if(v) return v.price*(qi?parseInt(qi.value)||1:1); }catch(e){} }
        return 0;
      }
      anchorInfo(){
        var vi = this.section.querySelector('form[id^="product-form-"] [name="id"]') || this.section.querySelector('input.product-variant-id');
        var qi = this.section.querySelector('input.quantity-input');
        return { id: vi ? parseInt(vi.value) : 0, qty: qi ? (parseInt(qi.value)||1) : 1 };
      }
      recalc(){
        var sel = this.selected();
        var total = this.anchorPrice();
        sel.forEach(function(c){ total += parseInt(c.dataset.price); });
        if(this.foot) this.foot.hidden = sel.length === 0;
        if(this.totalEl) this.totalEl.textContent = this.money(total);
        if(this.ship){
          var pct = Math.min(100, Math.round(total / this.freeShip * 100));
          if(this.shipFill) this.shipFill.style.width = pct + '%';
          if(total >= this.freeShip){
            this.ship.classList.add('is-done');
            if(this.shipMsg) this.shipMsg.innerHTML = '🚚 <span class="amt">Frete grátis desbloqueado!</span>';
          } else {
            this.ship.classList.remove('is-done');
            if(this.shipMsg) this.shipMsg.innerHTML = '🚚 Faltam <span class="amt">' + this.money(this.freeShip - total) + '</span> para o frete grátis';
          }
        }
        this.syncQtyBar(total);
      }
      syncQtyBar(total){
        var qc = this.section.querySelector('quantity-discount-cards');
        if(!qc) return;
        var ship = qc.querySelector('[data-ship]');
        if(!ship) return;
        var fill = qc.querySelector('[data-ship-fill]');
        var msg = qc.querySelector('[data-ship-msg]');
        var pct = Math.min(100, Math.round(total / this.freeShip * 100));
        if(fill) fill.style.width = pct + '%';
        if(total >= this.freeShip){
          ship.classList.add('is-done');
          if(msg) msg.innerHTML = '<span class="amt">Frete grátis desbloqueado!</span> 🎉';
        } else {
          ship.classList.remove('is-done');
          if(msg) msg.innerHTML = 'Faltam <span class="amt">' + this.money(this.freeShip - total) + '</span> para o frete grátis';
        }
      }
      checkout(btn){
        var a = this.anchorInfo();
        if(!a.id){ btn.click(); return; }
        var items = [{ id: a.id, quantity: a.qty }];
        this.selected().forEach(function(c){ items.push({ id: parseInt(c.dataset.variant), quantity: 1 }); });
        fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ items: items })
        }).then(function(){ window.location.href = '/checkout'; })
          .catch(function(){ window.location.href = '/cart'; });
      }
      money(cents){
        var a=(cents/100).toFixed(2), p=a.split('.'), ip=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.'), dp=p[1], f=this.moneyFormat;
        var m=function(k){return String.fromCharCode(123,123)+k+String.fromCharCode(125,125);};
        return f.replace(m('amount_with_comma_separator'),ip+','+dp).replace(m('amount_no_decimals_with_comma_separator'),ip).replace(m('amount_no_decimals'),p[0]).replace(m('amount'),a);
      }
    }
    customElements.define('order-bump-cards', OrderBumpCards);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-quantity-cards"] && !Shopify.designMode) return;
  try {
    class QuantityDiscountCards extends HTMLElement {
connectedCallback(){
this.cards = Array.prototype.slice.call(this.querySelectorAll('.qty2__opt'));
this.installments = parseInt(this.dataset.installments) || 3;
this.moneyFormat = this.dataset.moneyFormat || '';
this.freeShip = parseInt(this.dataset.freeShip) || 34900;
this.legendVal = this.querySelector('.qty2__legend-val');
this.ship = this.querySelector('[data-ship]');
this.shipFill = this.querySelector('[data-ship-fill]');
this.shipMsg = this.querySelector('[data-ship-msg]');
var self = this;
this.cards.forEach(function(card){
card.addEventListener('click', function(){ self.select(card); });
card.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); self.select(card); } });
});
this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-kvar]'));
this.chips.forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); self.pickFlavor(b); }); });
this.observeVariant();
var active = this.querySelector('.qty2__opt.is-active') || this.cards[0];
if(active){ this.apply(active); this.legend(active); this.updateShip(active); }
}
apply(card){
var qty = parseInt(card.dataset.quantity);
var section = this.closest('[id^="shopify-section-"]');
var input = section ? section.querySelector('input.quantity-input') : document.querySelector('input.quantity-input');
if(input){ input.value = qty; input.dispatchEvent(new Event('change',{bubbles:true})); }
}
select(card){
this.cards.forEach(function(c){ c.classList.remove('is-active'); c.setAttribute('aria-checked','false'); });
card.classList.add('is-active'); card.setAttribute('aria-checked','true');
this.apply(card); this.legend(card); this.updateShip(card);
}
legend(card){ if(this.legendVal){ var t=card.querySelector('.qty2__q'); this.legendVal.textContent = t ? t.textContent.trim() : ''; } }
priceOf(card){
var qty=parseInt(card.dataset.quantity), disc=parseInt(card.dataset.discount), unit=parseInt(this.dataset.unitPrice);
var total=unit*qty; return total - Math.floor(total*disc/100);
}
updateShip(card){
if(!this.ship) return;
var price=this.priceOf(card);
var pct=Math.min(100, Math.round(price/this.freeShip*100));
if(this.shipFill) this.shipFill.style.width = pct+'%';
if(price>=this.freeShip){
this.ship.classList.add('is-done');
if(this.shipMsg) this.shipMsg.innerHTML='<span class="amt">Frete grátis desbloqueado!</span> 🎉';
} else {
this.ship.classList.remove('is-done');
if(this.shipMsg) this.shipMsg.innerHTML='Faltam <span class="amt">'+this.money(this.freeShip-price)+'</span> para o frete grátis';
}
}
observeVariant(){
var self=this, section=this.closest('[id^="shopify-section-"]');
var vinput = section ? section.querySelector('input.product-variant-id') : document.querySelector('input.product-variant-id');
var pjson = section ? section.querySelector('.productJson') : document.querySelector('.productJson');
if(!vinput||!pjson) return;
var data; try{ data=JSON.parse(pjson.textContent); }catch(e){ return; }
var upd=function(){ var id=parseInt(vinput.value); var v=data.variants.find(function(x){return x.id===id;}); if(v){ self.reprice(v.price); self.syncChips(id); } };
new MutationObserver(upd).observe(vinput,{attributes:true,attributeFilter:['value']});
vinput.addEventListener('change',upd);
}
syncChips(id){
if(!this.chips||!this.chips.length) return;
this.chips.forEach(function(c){ var on=parseInt(c.dataset.kvar)===id; c.classList.toggle('is-on',on); c.setAttribute('aria-pressed',on?'true':'false'); });
}
pickFlavor(b){
var id=parseInt(b.dataset.kvar); this.syncChips(id);
var section=this.closest('[id^="shopify-section-"]')||document;
var wrap=b.closest('[data-kopt]'), opt=wrap?wrap.dataset.kopt:'', val=b.dataset.kval, radio=null;
Array.prototype.forEach.call(section.querySelectorAll('input[type="radio"]'), function(r){ if(!radio && r.value===val && (!opt || r.name===opt)) radio=r; });
if(radio){ if(!radio.checked) radio.click(); return; }
var vinput=section.querySelector('input.product-variant-id');
if(vinput){ vinput.value=id; vinput.setAttribute('value',id); vinput.dispatchEvent(new Event('change',{bubbles:true})); }
try{ var u=new URL(window.location.href); u.searchParams.set('variant',id); history.replaceState(null,'',u.toString()); }catch(e){}
}
reprice(unit){
var self=this; this.dataset.unitPrice=unit;
this.cards.forEach(function(card){
var qty=parseInt(card.dataset.quantity), disc=parseInt(card.dataset.discount);
var total=unit*qty, damt=Math.floor(total*disc/100), price=total-damt;
var per=Math.floor(price/qty), inst=Math.floor(price/self.installments), free=price>=self.freeShip;
var set=function(s,v){var el=card.querySelector(s); if(el) el.textContent=v;};
set('[data-installment]', self.money(inst)); set('[data-total]', self.money(price));
set('[data-compare]', self.money(total)); set('[data-perunit]', self.money(per)+'/pote');
var sv=card.querySelector('[data-savebox]'); if(sv){ sv.hidden=!(damt>0||free); sv.textContent = damt>0 ? '✓ Você economiza '+self.money(damt)+(free?' + frete grátis':'') : '✓ Frete grátis pra todo o Brasil'; }
var fs=card.querySelector('[data-freeship]'); if(fs) fs.hidden=!free;
});
var active=this.querySelector('.qty2__opt.is-active'); if(active) this.updateShip(active);
}
money(cents){
var a=(cents/100).toFixed(2), p=a.split('.'), ip=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.'), dp=p[1], f=this.moneyFormat;
var m=function(k){return String.fromCharCode(123,123)+k+String.fromCharCode(125,125);};
return f.replace(m('amount_with_comma_separator'),ip+','+dp).replace(m('amount_no_decimals_with_comma_separator'),ip).replace(m('amount_no_decimals'),p[0]).replace(m('amount'),a);
}
}
customElements.define('quantity-discount-cards', QuantityDiscountCards);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide-parent"] && !Shopify.designMode) return;
  try {
    function addAnimateDelayToSlides() {
    const swiperWrappers = document.querySelectorAll('.swiper-wrapper_parent');
    swiperWrappers.forEach(function(swiperWrapper) {
      const slideItems = swiperWrapper.querySelectorAll('.swiper-slide_item');
      slideItems.forEach(function(slideItem, index) {
        if (index > 0) {
          const contentSlides = slideItem.querySelectorAll('.content-slide');
          contentSlides.forEach(function(contentSlide) {
            contentSlide.classList.add('animate-delay');
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', addAnimateDelayToSlides);
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:reorder', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:load', addAnimateDelayToSlides);
  }
  } catch(e) { console.error(e); }
})();

})();
